import { ConfigProvider } from 'antd'
import 'antd/dist/antd.css'
import itIT from 'antd/lib/locale/it_IT'
import 'moment/locale/it'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { MobileDetection } from 'MobileDetection'
import PushNotification from 'components/PushNotification'
import RiminiPage from 'components/RiminiPage/RiminiPage'
import { Demo } from 'pages'
import { ToastContainer } from 'react-toastify'
import { isVisible } from 'utils/CheckVisibleElement'
import { initializeSentry } from 'utils/SentryService'

initializeSentry()

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={itIT}>
      {window.location.pathname.includes('/demo') ? (
        <Demo />
      ) : window.location.pathname.includes('/rimini') ? (
        <RiminiPage />
      ) : /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
        isVisible('index.mobiledetection') ? (
        <MobileDetection />
      ) : (
        <App />
      )}
      <ToastContainer />
      <PushNotification />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
